import React from 'react';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Button } from '@uhg-abyss/web/ui/Button';
import { redirectToAzureLogin } from '../../auth/api';

export const SignedOut = () => {
  return (
    <Layout.Stack
      alignLayout="center"
      css={{
        minHeight: '100vh',
        padding: '24px',
        background: 'radial-gradient(circle at 20% 10%, #d7f2ff 0%, #eef7ff 42%, #f7f9ff 100%)',
      }}
    >
      <div
        style={{
          width: 'min(560px, 94vw)',
          borderRadius: '20px',
          border: '1px solid #c7d6f8',
          background: 'linear-gradient(160deg, #ffffff 0%, #f6f9ff 100%)',
          boxShadow: '0 18px 50px rgba(28, 62, 120, 0.18)',
          padding: '28px 24px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '14px',
            marginBottom: '14px',
          }}
        >
          <div
            style={{
              width: '44px',
              height: '44px',
              borderRadius: '12px',
              background: 'linear-gradient(135deg, #004f91 0%, #00a1d6 100%)',
              color: '#ffffff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 700,
              fontSize: '18px',
              letterSpacing: '0.4px',
            }}
          >
            RFI
          </div>
          <div>
            <div style={{ fontSize: '20px', fontWeight: 700, color: '#17356f' }}>Signed out from Entra ID</div>
            <div style={{ fontSize: '14px', color: '#46618f' }}>
              Your session has ended and your workspace is secure.
            </div>
          </div>
        </div>

        <div
          role="status"
          aria-live="polite"
          style={{
            display: 'grid',
            gap: '10px',
            borderRadius: '14px',
            border: '1px solid #d6e2fa',
            background: '#f8fbff',
            padding: '14px',
            marginBottom: '14px',
          }}
        >
          <Text>You are signed out.</Text>
          <Text>Sign in again when you are ready to continue.</Text>
        </div>

        <div style={{ display: 'block' }}>
          <Button onClick={redirectToAzureLogin} variant="filled" color="brand">
            Sign in again
          </Button>
        </div>
      </div>
    </Layout.Stack>
  );
};
